const o = (t) => ({
  formWrapper: {
    padding: 0,
    maxWidth: 680,
    margin: "0 auto",
    textAlign: "left"
  },
  form: {
    padding: 0
  },
  formTitle: {
    color: t.palette.common.blue400,
    fontSize: t.typography.fontSize18,
    fontWeight: t.typography.fontWeightBold,
    marginBottom: 24
  },
  divider: {
    borderColor: t.palette.common.blue100
  },
  submitBtn: {
    maxWidth: 260,
    textTransform: "capitalize"
  }
}), a = o;
export {
  a as default
};
